import { render, staticRenderFns } from "./ConfirmationDialogNew.vue?vue&type=template&id=05fa3d38&"
import script from "./ConfirmationDialogNew.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDialogNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports